module.exports = __webpack_public_path__ + "img/secured.46c557c0.svg";